

/* eslint-disable */
import { ref, set } from 'vue';
import { defineStore, storeToRefs } from 'pinia';
import { productEndpoint } from '../services/nopAPI';

export const useProductStore = defineStore('product', () => {
  const productIds = ref([]);
  const productDetailData = ref({})

  async function getProductsDetailsById(id) {
    if(productDetailData.value[id] && productDetailData.value[id].detailsLoaded) {
      return productDetailData.value[id]
    }
    const response = await productEndpoint.getProductsByIds(id)
    if(!productDetailData.value[id]) productDetailData.value[id] = {}
    productDetailData.value[id] = Object.assign(productDetailData.value[id], response.Product, {detailsLoaded: true})
    return productDetailData.value[id]
  }

  return { productIds, getProductsDetailsById }
});
